import styled, { css } from "styled-components/native";
import {
  Feather as IconsFE,
  FontAwesome5 as IconsFA5,
} from "@expo/vector-icons";
import { themes } from "../../../design/colors";

interface DashboardProps {
  deliveryType: number;
}

export const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 0 20px;
`;

export const HeaderInfos = styled.View`
  flex: 1;
  margin-left: 15px;
`;

export const TextWelcome = styled.Text`
  color: ${themes.colors.black};
  font-size: 12px;
`;

export const NameUser = styled.Text`
  color: ${themes.colors.black};
  font-size: 22px;
  font-weight: bold;
  line-height: 35px;
`;

export const IconFE = styled(IconsFE)`
  color: red;
`;

export const IconFA5 = styled(IconsFA5)`
  color: ${themes.colors.primary};
`;

export const TitleMain = styled.View`
  flex-direction: row;
  margin-top: 20px;
  margin-bottom: 10px;
`;

export const Deliveries = styled.Text`
  color: ${themes.colors.black};
  font-weight: bold;
  font-size: 22px;
`;

export const OrderingOptions = styled.View`
  position: absolute;
  right: 0;
  flex-direction: row;
`;

export const TextPending = styled.Text<DashboardProps>`
  ${(props) =>
    props.deliveryType === 0
      ? css`
          color: ${themes.colors.primary};
          margin-right: 15px;
          text-decoration: underline;
          text-decoration-color: ${themes.colors.primary};
          font-weight: bold;
        `
      : css`
          color: #999999;
        `};
`;

export const TextHandedOut = styled.Text<DashboardProps>`
  ${(props) =>
    props.deliveryType === 1
      ? css`
          color: ${themes.colors.primary};
          margin-left: 15px;
          text-decoration: underline;
          text-decoration-color: ${themes.colors.primary};
          font-weight: bold;
        `
      : css`
          color: #999999;
        `};
`;

export const ButtonTextPending = styled.TouchableOpacity``;

export const ButtonTextHandedOut = styled.TouchableOpacity``;
